import {
    STATO_IN_ATTESA, STATO_IN_CARICO, STATO_IN_PROGRAMMAZIONE, STATO_LAVORI_IN_CORSO, STATO_CHIUSA, TIPOLOGIA_RIFIUTI
} from '@/costanti_report'

export function descriptionForSegnalazioneState(id: number) {
    
    switch (id) {
        case STATO_IN_ATTESA:
            return 'In attesa'
        case STATO_IN_CARICO:
            return 'In carico'
        case STATO_IN_PROGRAMMAZIONE:
            return 'In programmazione'
        case STATO_LAVORI_IN_CORSO:
            return 'Lavori in corso'
        case STATO_CHIUSA:
            return 'Chiusa'
        default:
            return 'Qualsiasi'
    }
}
